import React from "react";

import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  IconButton,
  Autocomplete,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";
import AddIcon from "@mui/icons-material/Add";

import { A4VALI } from "../../../Validation";
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import moment from "moment/moment";
import ComponentLoader from "../../../../ComponentLoader";

function A4Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [options, setOptions] = useState([]);
  // Comman Id Send to set value
  const [courseDetailsId, setCourseDetailsId] = useState("");

  const [courseDetails, setCourseDetails] = useState(null);
  const [date, setdate] = useState();
  const [InstituteId, setInstituteId] = useState("");
  const [NoOfStudents, setNoOfStudents] = useState("");

  const [courseDetailsErr, setCourseDetailsErr] = useState(false);
  const [dateErr, setdateErr] = useState(false);
  const [InstituteIdErr, setInstituteIdErr] = useState(false);
  const [NoOfStudentsErr, setNoOfStudentsErr] = useState(false);
  const [loader,setLoader] =useState(true);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();

  const [dirr, setDepartment] = useState([]);

  const [dropcourse, setDropcourse] = useState([]);
  const [hourss, sethourss] = useState("");

  const [CourseName, setCourseName] = useState("");
  const [courseType, setCourseType] = useState("");
  const [dropcoursetype, setDropcoursetype] = useState([]);
  const [dropnature, setDropnature] = useState([]);
  const [courseNo, setCourseNo] = useState("");

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(A4VALI),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      handleNaturetypes(tok);
      handleDirectorate(tok);
      handleCoursetypes(tok);
      handleInstituteName(tok);
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("visits arranged");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);

  const backs = () => {
    navigate("/A4");
  };

  const edit = (item) => {
    console.log(item);
    setCourseDetailsId(item.courseId);
    setdate(moment(item.exposureVisitsDate).format("YYYY-MM-DD"));
    setInstituteId(item.institute);
    setNoOfStudents(item.noOfStudents);
    setId(item.id);
  };

  useEffect(() => {
    console.log("========== ", options);
    options.forEach((item) => {
      console.log(item);
    });
    const getValue = options.find((data) => data.id === courseDetailsId);
    setCourseDetails(getValue);
  }, [dropcourse, courseDetailsId]);

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  //dropdown

  const handleCoursetypes = async (token) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.COURSEALL}`, {
        headers: h,
      });
      console.log(data);
      setDropcoursetype(data);
      setDropcourse(data);
      setOptions(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNaturetypes = async (token, CourseType) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"CourseType"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setDropnature(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleInstituteName = async (token) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.INSTITUTES}`, {
        headers: h,
      });
      console.log(data);
      setDepartment(data); setLoader(false);
    } catch (error) {
      console.log(error); setLoader(false);
    }
  };

  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);

    const d = {
      id,
      CourseNumber: courseDetails.courseNo,
      CourseId: parseInt(courseDetails.id),
      ExposureVisitsDate: date,
      Hours: courseDetails.hours,
      Institute: InstituteId,
      NoOfStudents: NoOfStudents,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.A4SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/A4");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }

        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.A4EDIT}`, d, {
          headers: h,
        });
        console.log(data);
        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/A4");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleDirectorate = async (token) => {
    console.log(token);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const { data } = await axios.get(`${window.BASE}${window.A4GETALL}`, {
        headers: h,
      });
      console.log(data); setLoader(false);
      // setStudentbtn(data);
    } catch (error) {
      console.log(error); setLoader(false);
    }
  };

  // const reload = () => {
  //   window.location.reload();
  // };

  const handleDialog = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const d = {
      id,
      CourseNo: courseNo,
      CourseName: CourseName,
      // CourseType: courseType,
      Hours : hourss
    };
    try {
      const { data } = await axios.post(
        `${window.BASE}${window.COURSESAVEBUT}`,
        d,
        { headers: h }
      );
      console.log(data);
      if (data.result == "Success") {
        alert("Successfully Submitted");
        // reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formValidateFun = () => {
    if (!courseDetails || Object.keys(courseDetails).length === 0) {
      setCourseDetailsErr(true);
      document.getElementById("dropcourse").focus();
    }else if (!date) {
      setdateErr(true);
      document.getElementById("date").focus();
    } else if (!InstituteId) {
      setInstituteIdErr(true);
      document.getElementById("InstituteId").focus();
    } else if (!NoOfStudents) {
      setNoOfStudentsErr(true);
      document.getElementById("NoOfStudents").focus();
    } else {
      handleLeavepage();
    }
  };

  return (
    <div className="main-container-margin">
      <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>

        <Dialog
          fullScreen={fullScreen}
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">
            <div className="dialogueTittle">
              <div>
                <h5>Course</h5>
              </div>
              <div onClick={handleClose}>
                <CloseIcon className="dialogue_close_icon" style={{ backgroundColor: "black" }}/>
              </div>
            </div>
          </DialogTitle>
          <DialogContent className="Dialog-box" style={{ padding: 0 }}>
            <div className="manu-form ">
              <div className="box width-50">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Course No"
                  value={courseNo}
                  variant="outlined"
                  size="small"
                  onChange={(e) => setCourseNo(e.target.value)}
                />
              </div>

              <div className="box width-50">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Course Name"
                  variant="outlined"
                  size="small"
                  value={CourseName}
                  onChange={(e) => setCourseName(e.target.value)}
                />
              </div>

              <div className="box width-50">
              <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Hours"
                  variant="outlined"
                  size="small"
                  value={hourss}
                  onChange={(e) => sethourss(e.target.value)}
                />
              </div>

              <div className="box width-50"></div>
            </div>
          </DialogContent>
          <DialogActions className="dialogue_action_button">
            <button type="submit" onClick={handleDialog}>
              Submit
            </button>
          </DialogActions>
        </Dialog>

        <div className="master-main-span">
          <span>Exposure visits (A4)</span>
        </div>
      </div>

      <div className="from-mains">
        <div className="form-control">
          <h5>A4. Exposure visits arranged:</h5>

          <div className="d-flex">
          <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={options}
              onChange={(e, val) => {
                setCourseDetails(val);
                setCourseDetailsErr(false);
              }}
              getOptionLabel={(option) =>
                `${option.courseNo} - ${option.courseName} - ${option.hours}`
              }
              value={courseDetails}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Course"
                  error={courseDetailsErr}
                />
              )}
            />
            {/* <FormControl style={{ width: "94%", margin: 12 }}>
              <Autocomplete
                id="demo-simple-select"
                options={dropcourse || []}
                getOptionLabel={(option) => `${option.courseNo} - ${option.courseName} - ${option.hours}`}
                filterOptions={(options, state) => {
                  const inputValue = state.inputValue.toLowerCase();
                  return options.filter(
                    (option) =>
                      option.courseName.toLowerCase().includes(inputValue) ||
                      option.courseNo.toLowerCase().includes(inputValue) ||
                      option.hours.toLowerCase().includes(state.inputValue.toLowerCase())
                  );
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setValue("CourseIdv", newValue.id);
                    setValue("CourseNumberv", newValue.courseNo);
                    setValue("hoursv", newValue.hours);
                  } else {
                    setValue("CourseIdv", null);
                    setValue("CourseNumberv", null);
                    setValue("hoursv", newValue.hours);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Course"
                    size="small"
                    sx={{ width: "100%" }}
                    error={errors.CourseIdV ? true : false}
                    helperText={errors.CourseIdV?.message}
                  />
                )}
                renderOption={(props, option) => (
                  <MenuItem {...props} key={option.id} value={option}>
                    {option.courseNo} - {option.courseName} -{" "}
                    {option.hours}
                  </MenuItem>
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <MenuItem key={option.id} {...getTagProps({ index })}>
                      {option.courseNo} - {option.courseName} -{" "}
                      {option.hours}
                    </MenuItem>
                  ))
                }
              />
            </FormControl> */}
            <div>
              <IconButton
                onClick={handleClickOpen}
                className="addbtn"
                style={{ fontSize: "14px", marginTop: "12px" }}
              >
                <AddIcon />
              </IconButton>
            </div>
          </div>

          <TextField
            error={dateErr}
            id="date"
            label="Date"
            type="date"
            variant="outlined"
            value={date}
            style={{ margin: "10px", width: "48%" }}
            onChange={(e)=>{
              setdate(e.target.value)
              setdateErr(false)
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              placeholder: "",
            }}
          />

          <TextField
            error={InstituteIdErr}
            id="InstituteId"
            label="Institute/Place Visited (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={InstituteId}
            onChange={(e)=>{
              setInstituteId(e.target.value)
              setInstituteIdErr(false)
            }}
          />

          <TextField
            error={NoOfStudentsErr}
            id="NoOfStudents"
            label=" No. of students"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={NoOfStudents}
            onChange={(e)=>{
              setNoOfStudents(e.target.value)
              setNoOfStudentsErr(false)
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA", height: "20px",padding:"5px 30px 28px 26px",borderRadius:"3px",color:"#fff" }}
              onClick={backs}
            >
              Back
            </button>
            <button type="submit" className="sbmit-buttons" onClick={formValidateFun} style={{paddingTop:"5px"}}>
            Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default A4Inside;
